import { render, staticRenderFns } from "./DesktopMenuSettings.vue?vue&type=template&id=b4664770"
import script from "./DesktopMenuSettings.vue?vue&type=script&lang=js"
export * from "./DesktopMenuSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports